<footer class="bg-gray-900 text-white">
  <div class="section-padding !pb-12">
    <div class="container-custom">
      <div class="grid lg:grid-cols-6 gap-12">
        <div class="lg:col-span-2">
          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-xl bg-primary-600 flex items-center justify-center">
              <i class="pi pi-eye text-xl text-white"></i>
            </div>
            <span class="text-xl font-bold">Pupil Lab</span>
          </div>
          <p class="text-gray-400 leading-relaxed mb-6 max-w-sm">
            {{ i18n.content().footer.description }}
          </p>
          <div class="flex gap-3">
            @for (social of socialLinks; track social.label) {
              <a
                [href]="social.href"
                [attr.aria-label]="social.label"
                class="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
              >
                <i class="pi {{ social.icon }} text-sm"></i>
              </a>
            }
          </div>
        </div>

        @for (column of i18n.content().footer.columns; track column.title) {
          <div>
            <h4 class="font-semibold text-sm uppercase tracking-wider mb-4 text-gray-300">{{ column.title }}</h4>
            <ul class="space-y-3">
              @for (link of column.links; track link) {
                <li>
                  <a href="#" class="text-gray-400 hover:text-white text-sm transition-colors duration-200">
                    {{ link }}
                  </a>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="border-t border-white/10">
    <div class="container-custom px-4 lg:px-16 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
      <p class="text-gray-500 text-sm">
        &copy; {{ currentYear }} Pupil Lab. {{ i18n.content().footer.rights }}
      </p>
      <div class="flex gap-6">
        <a href="#" class="text-gray-500 hover:text-gray-300 text-sm transition-colors">
          {{ i18n.content().footer.privacy }}
        </a>
        <a href="#" class="text-gray-500 hover:text-gray-300 text-sm transition-colors">
          {{ i18n.content().footer.terms }}
        </a>
        <a href="#" class="text-gray-500 hover:text-gray-300 text-sm transition-colors">
          {{ i18n.content().footer.cookies }}
        </a>
      </div>
    </div>
  </div>
</footer>
